import { IUser } from 'app/shared/model/user.model';
import { IQuestion } from 'app/shared/model/question.model';

export interface IConnection {
  id?: number;
  status?: string;
  userMentor?: IUser | null;
  userMentee?: IUser | null;
  questions?: IQuestion[] | null;
}

export const defaultValue: Readonly<IConnection> = {};
